import captureStackTrace from "capture-stack-trace";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { App } from "./App";

Error.captureStackTrace ||= captureStackTrace;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);
